import { animateCurrentProgressBar } from "@/modules/actions/headerLineDuration";
import { trackStoreeelEvent } from "@/helpers/trackStoreeelEvent";
import localStorageRepositories from "@/plugins/localStorageRepositories";

// 動画を開いた時に一番初めに実行される関数
export const playEventHandler = () => {
  const activeSlide = document.querySelector('.storeeel-swiper-group-wrapper .swiper-slide-active');
  if (!activeSlide) return;
  const video = activeSlide.querySelector('.storeeel-movie');
  if (video) {
    video.addEventListener('loadedmetadata', () => {
      const duration = video.duration;
      const banners = document.querySelectorAll('.storeeel-movie-select_banner');

      // square フレームなら常に先頭、それ以外は window.moviePosition または 0
      const { isMobile, frame } = window.storeeelItems;
      const index = (!isMobile && frame === 'square')
        ? 0
        : (window.moviePosition || 0);

      const banner = banners[index];
      // banner がなければ、あるいは active／completed がついていれば何もしない
      if (!banner || banner.classList.contains('active') || banner.classList.contains('completed')) {
        return;
      }

      // アニメーション開始
      animateCurrentProgressBar(duration, index);
    });
  }

  const image = activeSlide.querySelector('.storeeel-media-image');
  if (image) {
    image.addEventListener('load', () => {
      if (!window.storeeelItems.isMobile) {
        animateCurrentProgressBar(5, window.moviePosition || 0);
      }
    });
  }

  if (window.storeeelItems.isMobile && window.storeeelItems.frame === 'circle') {
    // activeSlide以外のCTAボタンを非表示にする
    const allWrappers = document.querySelectorAll('.storeeel-swiper-group-wrapper .swiper-slide .slide-media-wrapper');
    allWrappers.forEach((wrapper) => {
      // 現在のグループID以外のCTAボタンを非表示にする
      const groupId = wrapper.getAttribute('group-id');
      if (groupId !== window.iconId) {
        const ctaButtons = wrapper.querySelectorAll('.ctaFrame');
        ctaButtons.forEach(ctaButton => {
          ctaButton.style.visibility = 'hidden';
        });
      }
    });
  }

  // GA4 viewイベントを送信
  let mediaName;
  let mediaId;
  if (video) {
    mediaName = video.getAttribute('media-name');
    mediaId = video.getAttribute('media-id');
  } else if (image) {
    mediaName = image.getAttribute('media-name');
    mediaId = image.getAttribute('media-id');
  }
  if (window.storeeelItems.frame === 'square') {
    trackMediaView(mediaName, mediaId, null);
  } else {
    trackMediaView(mediaName, mediaId, window.iconId);
  }

  // localStorageに保存
  setLocalStorage(mediaId);
};

function trackMediaView(mediaName, mediaId, groupId) {
  trackStoreeelEvent('storeeel_media_asset_view', {
    'storeeel_name':  mediaName,
    'group_id': groupId,
    'media_id': mediaId,
    'campaign_id': window.storeeelItems.id,
  })
}

function setLocalStorage(mediaId) {
  localStorageRepositories.get("mediaView").set(
    mediaId,
    window.storeeelItems.id
  )
}
